var map = {
	"./AAVE.svg": 386,
	"./AAVEe.svg": 387,
	"./ADA.svg": 388,
	"./ADX.svg": 389,
	"./ALPACA.png": 390,
	"./ALPHA.png": 391,
	"./AMPL.png": 392,
	"./ANN.png": 393,
	"./ANY.png": 394,
	"./ARBITRUM.svg": 395,
	"./ATOM.png": 396,
	"./AURO.png": 397,
	"./AVALANCHE.svg": 398,
	"./AVAX.png": 399,
	"./AVAX.svg": 400,
	"./AXS.png": 401,
	"./BABY.svg": 402,
	"./BABYCAKE.svg": 403,
	"./BAKE.png": 404,
	"./BALL.png": 405,
	"./BANANA.svg": 406,
	"./BCH.svg": 407,
	"./BDO.png": 408,
	"./BDP.png": 409,
	"./BEAR.png": 410,
	"./BETA.svg": 411,
	"./BETH.png": 412,
	"./BETU.png": 413,
	"./BHC.png": 414,
	"./BIFI.png": 415,
	"./BISON.png": 416,
	"./BITADA.png": 417,
	"./BITATOM.png": 418,
	"./BITBTC.png": 419,
	"./BITDOT.png": 420,
	"./BITSHARE.png": 421,
	"./BLZZ.svg": 422,
	"./BMON.svg": 423,
	"./BNB.png": 424,
	"./BOHM.png": 425,
	"./BOMB.png": 426,
	"./BOMBSWAP.png": 427,
	"./BONE.png": 428,
	"./BONEswap.png": 429,
	"./BOO.png": 430,
	"./BORING.png": 431,
	"./BP.png": 432,
	"./BREW.png": 433,
	"./BSC.svg": 434,
	"./BSCDEFI.svg": 435,
	"./BSCPAD.png": 436,
	"./BSHARE.png": 437,
	"./BTC.svg": 438,
	"./BTCB.svg": 439,
	"./BTD.png": 440,
	"./BTS.png": 441,
	"./BTT.png": 442,
	"./BUNNY.png": 443,
	"./BURGER.png": 444,
	"./BUSD.svg": 445,
	"./BUSDe.svg": 446,
	"./BUSM.png": 447,
	"./CAKE.svg": 448,
	"./CAPS.svg": 449,
	"./CARROT.png": 450,
	"./CEEK.png": 451,
	"./CELO.svg": 452,
	"./CHESS.svg": 453,
	"./CRA.png": 454,
	"./CRO.svg": 455,
	"./CRONA.svg": 456,
	"./CRONOS.svg": 457,
	"./CRV.png": 458,
	"./CRYSTL.png": 459,
	"./CTK.png": 460,
	"./CYT.png": 461,
	"./CZBNB.png": 462,
	"./CZBOMB.png": 463,
	"./CZBUSD.png": 464,
	"./CZEMP.png": 465,
	"./CZETH.png": 466,
	"./CZF.png": 467,
	"./CZSHARE.png": 468,
	"./CZSHARES.png": 469,
	"./DAI.png": 470,
	"./DAI.svg": 471,
	"./DAIe.png": 472,
	"./DAR.svg": 473,
	"./DELIRIUM.png": 474,
	"./DEP.png": 475,
	"./DFYN.png": 476,
	"./DG.png": 477,
	"./DINO.png": 478,
	"./DIS.svg": 479,
	"./DKT.png": 480,
	"./DOGE.svg": 481,
	"./DOLA.png": 482,
	"./DOT.png": 483,
	"./DPI.png": 484,
	"./DRUGS.png": 485,
	"./DVI.svg": 486,
	"./ELK.png": 487,
	"./EMP.png": 488,
	"./EPS.png": 489,
	"./ETERNAL.png": 490,
	"./ETH.svg": 491,
	"./EURt.png": 492,
	"./EXP.svg": 493,
	"./EZ.png": 494,
	"./FANTOM.svg": 495,
	"./FET.png": 496,
	"./FFF.png": 497,
	"./FIL.svg": 498,
	"./FINN.png": 499,
	"./FISH.svg": 500,
	"./FOO.png": 501,
	"./FORM.svg": 502,
	"./FOX.png": 503,
	"./FRAX.svg": 504,
	"./FRUIT.png": 505,
	"./FTM.png": 506,
	"./FXS.png": 507,
	"./GEIST.svg": 508,
	"./GHST.png": 509,
	"./GNT.png": 510,
	"./GOLDCOIN.svg": 511,
	"./GUARD.svg": 512,
	"./HAI.png": 513,
	"./HARD.png": 514,
	"./HARMONY.svg": 515,
	"./HBTC.png": 516,
	"./HECO.svg": 517,
	"./HERO.png": 518,
	"./HONEY.png": 519,
	"./HONOR.png": 520,
	"./HOTCROSS.svg": 521,
	"./HPS.png": 522,
	"./HT.png": 523,
	"./HTB.svg": 524,
	"./HUSD.png": 525,
	"./ICA.svg": 526,
	"./ICE.png": 527,
	"./IF.svg": 528,
	"./INCH.png": 529,
	"./INJ.png": 530,
	"./INV.png": 531,
	"./IRON.png": 532,
	"./JETS.png": 533,
	"./JOE.png": 534,
	"./JRT.png": 535,
	"./JULD.png": 536,
	"./JUST.png": 537,
	"./KART.png": 538,
	"./KEBAB.png": 539,
	"./KRW.png": 540,
	"./LAND.svg": 541,
	"./LAZIO.png": 542,
	"./LINK.png": 543,
	"./LINKe.png": 544,
	"./LITHIUM.svg": 545,
	"./LONG.png": 546,
	"./LTC.svg": 547,
	"./LUNA.png": 548,
	"./MAI.png": 549,
	"./MANA.png": 550,
	"./MARSH.png": 551,
	"./MASK.svg": 552,
	"./MATIC.svg": 553,
	"./MCB.png": 554,
	"./MCRN.svg": 555,
	"./MDX.png": 556,
	"./MERL.svg": 557,
	"./METAHERO.svg": 558,
	"./MIM.png": 559,
	"./MOON.png": 560,
	"./MOONRIVER.svg": 561,
	"./MOVR.png": 562,
	"./MSC.png": 563,
	"./MSS.png": 564,
	"./MUST.png": 565,
	"./NAOS.png": 566,
	"./NEXO.png": 567,
	"./NFT.png": 568,
	"./NFTY.png": 569,
	"./NUGGET.svg": 570,
	"./NUTS.png": 571,
	"./NYA.png": 572,
	"./NYAC.png": 573,
	"./NYAS.png": 574,
	"./O3.png": 575,
	"./OASIS.svg": 576,
	"./OCP.png": 577,
	"./ONE.svg": 578,
	"./ONG.svg": 579,
	"./ONT.png": 580,
	"./OOE.svg": 581,
	"./ORBS.svg": 582,
	"./PACOCA.svg": 583,
	"./PAUTO.png": 584,
	"./PBNB.png": 585,
	"./PEAR.svg": 586,
	"./PERA.png": 587,
	"./PETS.png": 588,
	"./PHA.png": 589,
	"./PHUB.png": 590,
	"./PMATIC.png": 591,
	"./PMP.svg": 592,
	"./PNG.svg": 593,
	"./POLYGON.svg": 594,
	"./PORTO.png": 595,
	"./POTS.png": 596,
	"./PSHARE.png": 597,
	"./PUP.png": 598,
	"./PolyDoge.png": 599,
	"./QBT.svg": 600,
	"./QI.png": 601,
	"./QUICK.png": 602,
	"./RABBIT.svg": 603,
	"./RAMP.png": 604,
	"./RELAY.png": 605,
	"./REVV.svg": 606,
	"./RIB.png": 607,
	"./ROUTE.png": 608,
	"./RPG.png": 609,
	"./SAGE.png": 610,
	"./SBDO.png": 611,
	"./SCREAM.png": 612,
	"./SFP.png": 613,
	"./SFUND.png": 614,
	"./SHADE.png": 615,
	"./SHIB.png": 616,
	"./SHIBX.png": 617,
	"./SING.png": 618,
	"./SISTA.svg": 619,
	"./SKILL.svg": 620,
	"./SMART.png": 621,
	"./SNOWAVAX.png": 622,
	"./SNOWLINK.png": 623,
	"./SNOWSHARE.png": 624,
	"./SNOWSOL.png": 625,
	"./SNX.png": 626,
	"./SOAK.png": 627,
	"./SOL.png": 628,
	"./SOLAR.png": 629,
	"./SPADE.png": 630,
	"./SPELL.png": 631,
	"./SPIRIT.png": 632,
	"./SPS.svg": 633,
	"./STARS.svg": 634,
	"./START.png": 635,
	"./STEAK.png": 636,
	"./STEEL.png": 637,
	"./SUMMIT.png": 638,
	"./SUSHI.png": 639,
	"./SUSHIe.png": 640,
	"./SWAMP.svg": 641,
	"./SX.png": 642,
	"./SXP.svg": 643,
	"./SYN.svg": 644,
	"./TAPE.svg": 645,
	"./TEL.png": 646,
	"./TENFI.png": 647,
	"./TETU.svg": 648,
	"./TIME.png": 649,
	"./TITAN.svg": 650,
	"./TLOS.svg": 651,
	"./TREEB.png": 652,
	"./TRX.png": 653,
	"./TUSD.png": 654,
	"./TYPH.png": 655,
	"./UFT.png": 656,
	"./UNI.png": 657,
	"./UNIe.png": 658,
	"./USDC.svg": 659,
	"./USDCe.svg": 660,
	"./USDO.png": 661,
	"./USDT.svg": 662,
	"./USDTe.svg": 663,
	"./UST.png": 664,
	"./VVS.svg": 665,
	"./WAN.svg": 666,
	"./WATCH.png": 667,
	"./WAULTx.svg": 668,
	"./WBNB.svg": 669,
	"./WBTC.svg": 670,
	"./WBTCe.svg": 671,
	"./WETH.svg": 672,
	"./WETHe.svg": 673,
	"./WEX.svg": 674,
	"./WEXpoly.png": 675,
	"./WIN.png": 676,
	"./WMATIC.svg": 677,
	"./WMATIC_DFYN.svg": 678,
	"./WOO.svg": 679,
	"./WOOFY.png": 680,
	"./WSG.svg": 681,
	"./WUSD.svg": 682,
	"./XAVA.png": 683,
	"./XBOMBSWAP.png": 684,
	"./XRP.svg": 685,
	"./XTZ.png": 686,
	"./XVS.png": 687,
	"./XWG.png": 688,
	"./YAMP.svg": 689,
	"./YEL.svg": 690,
	"./YELD.png": 691,
	"./YFI.png": 692,
	"./YFIe.png": 693,
	"./YGG.png": 694,
	"./ZBTC.svg": 695,
	"./ZETH.svg": 696,
	"./ZOO.png": 697,
	"./aQI.png": 698,
	"./aROME.png": 699,
	"./anyMTLX.png": 700,
	"./bQI.png": 701,
	"./bscBUSD.svg": 702,
	"./cEUR.png": 703,
	"./cUSD.png": 704,
	"./cakeHARD.png": 705,
	"./cakeROOBEE.png": 706,
	"./cakeSTAX.png": 707,
	"./cakeTWT.png": 708,
	"./cakebROOBEE.png": 709,
	"./fUSD.png": 710,
	"./fUSDT.png": 711,
	"./fWINGS.svg": 712,
	"./ibBTC.svg": 713,
	"./jCHF.png": 714,
	"./jEUR.png": 715,
	"./jGBP.png": 716,
	"./miMatic.png": 717,
	"./pBREW.png": 718,
	"./pOPEN.webp": 719,
	"./pWINGS.png": 720,
	"./polyBUNNY.png": 721,
	"./polyWISE.png": 722,
	"./rUSD.svg": 723,
	"./renBTC.png": 724,
	"./renBTC.svg": 725,
	"./renDGB.svg": 726,
	"./renDOGE.png": 727,
	"./sALPACA.svg": 728,
	"./sSPELL.png": 729,
	"./wMEMO.png": 730,
	"./xMARK.png": 731,
	"./xYELD.svg": 732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1130;